import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useLocalizedStrings() {
  const { localizedStrings } = useWebChatAPIContext();

  return localizedStrings;
}
